/**
 * This is a collection of shards.
 *
 * It comes preconfigured with the correct endpoint from which data will be
 * fetched upon module instantiation.
 */

import Brace from "backbone.brace";
import Model from "../models/shard";
import environment from "../common/environment";

const Collection = Brace.Collection.extend({
  comparator: "description",
  url: environment.getEndpoint("shards"),
  model: Model,
  initialize() {
    this.promise = this.fetch();
  },
});

export { Collection as default };
